import { GameWithoutLivestream } from '../types'

export const getViewerPageUrl = (
  mediaObject: GameWithoutLivestream,
  rootDomain: string
) => {
  const baseUrl = `${process.env.REACT_APP_PROTOCOLL}${process.env.REACT_APP_SERVER_URL}`
  const pageDomain = rootDomain ? `https://${rootDomain}` : baseUrl
  const rootDomainViewerPageUrl =
    mediaObject.id && mediaObject.display_company.subdomain
      ? `${pageDomain}/${mediaObject.display_company.subdomain}/games/g/${mediaObject.id}`
      : pageDomain
  return rootDomainViewerPageUrl
}
